import { TInfrastructureItem } from '../../../../../types/map';

export function getTimeWalk(infrastructureItem: TInfrastructureItem): string | undefined {
  if ('timeWalk' in infrastructureItem) {
    return `~ ${infrastructureItem.timeWalk} мин. пешком`;
  }

  return undefined;
}
